import React, { useState, useEffect, useRef } from 'react';
    import Logo from '../SettingsHeader/images/logo2.png'
    import SandboxLogo from '../SettingsHeader/images/SandboxBadge.dac96828.svg'
    import { useLocation } from 'react-router-dom';
    import { ENDPOINT} from '../../variaveis';
    import { useNavigate } from 'react-router-dom';
    import resets from './_resets.module.css';
    import { ClarityTwoWayArrowsLineIcon } from './ClarityTwoWayArrowsLineIcon.js';
import classes from './DivZ20.module.css';
import { FontistoMoneySymbolIcon } from './FontistoMoneySymbolIcon.js';
import { FrameIcon2 } from './FrameIcon2.js';
import { FrameIcon } from './FrameIcon.js';
import { StreamlineMoneyWalletMoneyPaym } from './StreamlineMoneyWalletMoneyPaym.js';
import { TablerHomeIcon } from './TablerHomeIcon.js';
import { useTranslation } from 'react-i18next';

function WalletHeader() {
  const { t, i18n} = useTranslation();
  const [showLogout, setShowLogout] = useState(false);
  const LogoutRef = useRef();
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const buttonRefLogout = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuVisible && LogoutRef.current && !LogoutRef.current.contains(event.target) && !buttonRefLogout.current.contains(event.target)) {
        setMenuVisible(false);
        
      }
    };
  
    document.addEventListener('click', handleClickOutside);
  
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [menuVisible]);


  const handleLogout = async () => {
    console.log('Response OK');
    const currentTime = Math.floor(Date.now() / 1000);
    localStorage.setItem('tokenExpiry', currentTime);

    const tokenExpiry = localStorage.getItem('tokenExpiry');
    console.log("TOKEN: ", tokenExpiry)
      const response = await fetch(`${ENDPOINT}/logout`, {
        method: 'PATCH',
        credentials: 'include',
        
      });
  
      console.log('Fetch completed'); 
      
      if (response.ok) {
       
        
         
      }; 
    }

    


  useEffect(() => {
    // Obtem os usuários do localStorage
    const loadedUsers = localStorage.getItem('userData');
    if (loadedUsers) {
      setUsers(JSON.parse(loadedUsers));
    }
      
  }, []);
  

    const [hoveredIndex, setHoveredIndex] = useState(null);
    
    const handleMouseEnter = (index) => {
      setHoveredIndex(index);
    };
  
    const handleMouseLeave = () => {
      setHoveredIndex(null);
    };
  

    const toggleMenu = () => {
      setMenuVisible(!menuVisible);
    };
  
    const isActiveMenuItem = (menuItem) => {
      // Retorne verdadeiro se o caminho corresponder à página atual
      return window.location.pathname === menuItem;
    };


 {/*                                                                                                   useEffect(() => {
      const handleOutsideClick = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
          setMenuVisible(false);
        }
      };
    
      if (menuVisible) {
        document.addEventListener('click', handleOutsideClick);
      }
    
      return () => {
        document.removeEventListener('click', handleOutsideClick);
      };
    }, [menuVisible]);

  */}
    
        
    return(<div
        className="z-20 flex h-screen w-min flex-col shadow-lg bg-black-700 fixed"
        data-testid="settings-nav"
        style={{background:'black'}}
      >
        <header className="flex p-3 pb-8">
          <a
            className="inline-block w-fit p-0"
            title="Home"
            aria-label="Home"
            href="/wallet"
          
          >
           
           <img src={Logo}    ></img>
          

          </a>

          
        </header>
        
        <div
          data-testid="scroll-container"
          className="cb-scroll-container with-overflow-mask bottom-mask h-full"
        >
          <div
            style={{
              position: "relative",
              overflow: "hidden",
              width: "100%",
              height: "100%"
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                overflow: "scroll",
                marginRight: "-17px",
                marginBottom: "-17px"
              }}
            >
              <div className="content">
                <div className="grid w-min grid-flow-row-dense auto-rows-min gap-y-3.5">
                  <nav className="cb-sidenav dark" data-testid="sidenav">
                    <span
                      className="cb-sidenav-group"
                      data-testid="sidenav-group"
                    >
                     
                      <span  className="group-items">
                      
                      
                      <a
                          className={`cb-sidenav-group-item${isActiveMenuItem("/wallet") ? " active" : ""}`}
                          title="Home"
                          href="/wallet"
                         
                        >
                            <svg style={{position:'absolute', width:'25px', background:'none'}} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' >
    <path
      d='M6.44444 15H4L15 4L26 15H23.5556M6.44444 15V23.5556C6.44444 24.2039 6.70198 24.8256 7.16041 25.284C7.61883 25.7425 8.24058 26 8.88889 26H21.1111C21.7594 26 22.3812 25.7425 22.8396 25.284C23.298 24.8256 23.5556 24.2039 23.5556 23.5556V15'
      stroke='#00DC84'
      strokeWidth={2.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.3333 26V18.6667C11.3333 18.0184 11.5909 17.3966 12.0493 16.9382C12.5077 16.4798 13.1295 16.2222 13.7778 16.2222H16.2222C16.8705 16.2222 17.4923 16.4798 17.9507 16.9382C18.4091 17.3966 18.6666 18.0184 18.6666 18.6667V26'
      stroke='#00DC84'
      strokeWidth={2.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>


                          <span style={{marginLeft:'25px'}} className="inner">Home</span>
                        </a>
                        <a
  className={`cb-sidenav-group-item${isActiveMenuItem("/activity") || isActiveMenuItem("/swap-history") ? " active" : ""}`}
  title="Activity"
  href="/activity"

  
>

<svg style={{position:'absolute', width:'25px', background:'none'}} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' >
    <g clipPath='url(#clip0_374_6)'>
      <path
        d='M19.525 14.025C19.3692 13.867 19.157 13.7773 18.9351 13.7758C18.7131 13.7742 18.4997 13.8609 18.3417 14.0167C18.1836 14.1725 18.094 14.3847 18.0924 14.6066C18.0909 14.8285 18.1775 15.042 18.3333 15.2L21.4333 18.3333H6.525C6.30399 18.3333 6.09202 18.4211 5.93574 18.5774C5.77946 18.7337 5.69167 18.9457 5.69167 19.1667C5.69167 19.3877 5.77946 19.5996 5.93574 19.7559C6.09202 19.9122 6.30399 20 6.525 20H21.4333L18.3333 23.0833C18.2562 23.161 18.1951 23.2532 18.1535 23.3545C18.112 23.4558 18.0908 23.5643 18.0912 23.6738C18.0916 23.7833 18.1135 23.8916 18.1558 23.9926C18.1981 24.0936 18.2598 24.1853 18.3375 24.2625C18.4152 24.3397 18.5073 24.4007 18.6086 24.4423C18.7099 24.4838 18.8184 24.505 18.9279 24.5046C19.0374 24.5042 19.1458 24.4823 19.2468 24.44C19.3478 24.3978 19.4395 24.336 19.5167 24.2583L24.6083 19.1667L19.525 14.025Z'
        fill='#00DC84'
      />
      <path
        d='M11.0333 15.375C11.1989 15.376 11.3609 15.3276 11.4988 15.2361C11.6368 15.1446 11.7443 15.0141 11.8078 14.8612C11.8713 14.7084 11.8878 14.5401 11.8552 14.3778C11.8227 14.2155 11.7425 14.0666 11.625 13.95L8.53333 10.8333H23.4333C23.6543 10.8333 23.8663 10.7455 24.0226 10.5893C24.1789 10.433 24.2667 10.221 24.2667 10C24.2667 9.77899 24.1789 9.56702 24.0226 9.41074C23.8663 9.25446 23.6543 9.16667 23.4333 9.16667H8.53333L11.625 6.05833C11.7022 5.98063 11.7632 5.8885 11.8048 5.78719C11.8463 5.68588 11.8675 5.57738 11.8671 5.46789C11.8667 5.35839 11.8448 5.25004 11.8025 5.14903C11.7603 5.04802 11.6985 4.95632 11.6208 4.87917C11.5431 4.80202 11.451 4.74092 11.3497 4.69938C11.2484 4.65783 11.1399 4.63665 11.0304 4.63704C10.8093 4.63782 10.5975 4.72641 10.4417 4.88333L5.35 10L10.4417 15.1167C10.5181 15.1969 10.6099 15.2611 10.7115 15.3055C10.8131 15.3498 10.9225 15.3735 11.0333 15.375Z'
        fill='#00DC84'
      />
    </g>
    <defs>
      <clipPath id='clip0_374_6'>
        <rect width={30} height={30} fill='white' />
      </clipPath>
    </defs>
  </svg>


  <span style={{marginLeft:'25px'}} className="inner">{t('transactions')}</span>
</a>

     {/*                   <a
  className={`cb-sidenav-group-item${isActiveMenuItem("/swap") ? " active" : ""}${users?.kyc?.level === 0 ? " disabled" : ""}`}
  title="Swap"
  href="/swap"
  onClick={(e) => {
    if (users?.kyc?.level === 0) {
      e.preventDefault();
    }
  }}
>


<svg style={{position:'absolute', width:'25px', background:'none'}} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' >
    <g clipPath='url(#clip0_374_10)'>
      <path
        d='M25.7692 16.0753V11.7671C25.7692 11.1958 25.5423 10.6478 25.1384 10.2439C24.7345 9.8399 24.1866 9.61294 23.6154 9.61294H3.15385C2.58261 9.61294 2.03477 9.8399 1.63085 10.2439C1.22692 10.6478 1 11.1958 1 11.7671V26.8459C1 27.4172 1.22692 27.9651 1.63085 28.3691C2.03477 28.773 2.58261 29 3.15385 29H23.6154C24.1866 29 24.7345 28.773 25.1384 28.3691C25.5423 27.9651 25.7692 27.4172 25.7692 26.8459V21.4606M8.19385 4.22765L20.4062 1.03956C20.5434 1.00089 20.687 0.990426 20.8284 1.00881C20.9698 1.02719 21.106 1.07403 21.2288 1.1465C21.3516 1.21897 21.4584 1.31557 21.5428 1.43048C21.6272 1.54538 21.6875 1.6762 21.72 1.81504L22.3231 4.22765'
        stroke='#00DC84'
        strokeWidth={2.14286}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.923 16.0753H22.5384C21.9436 16.0753 21.4615 16.5575 21.4615 17.1524V20.3835C21.4615 20.9784 21.9436 21.4606 22.5384 21.4606H27.923C28.5178 21.4606 28.9999 20.9784 28.9999 20.3835V17.1524C28.9999 16.5575 28.5178 16.0753 27.923 16.0753Z'
        stroke='#00DC84'
        strokeWidth={2.14286}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_374_10'>
        <rect width={30} height={30}  />
      </clipPath>
    </defs>
  </svg>

  <span style={{marginLeft:'25px'}} className="inner">Pagamentos</span>
</a>

*/}
                       


                       {/* <a
                          className={`cb-sidenav-group-item${isActiveMenuItem("api-keys") ? " active" : ""}`}
                          title="Blockchain addresses"
                          href="/api-keys"
                          
                        >
                          <span className="inner">Developer</span>
            </a>*/}
                      </span>
                    </span>
                   
                     
                        
                        
                        
                  </nav>
                </div>
                <div className="scroll-end" />
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                height: 6,
                transition: "opacity 200ms ease 0s",
                opacity: 0,
                right: 2,
                bottom: 2,
                left: 2,
                borderRadius: 3,
                visibility: "hidden"
              }}
            >
              <div
                style={{
                  position: "relative",
                  display: "block",
                  height: "100%",
                  cursor: "pointer",
                  borderRadius: "inherit",
                  backgroundColor: "rgba(0, 0, 0, 0.2)",
                  width: 0
                }}
              />
            </div>
            <div
              className="track-vertical"
              data-testid="track-vertical"
              style={{
                position: "absolute",
                width: 6,
                transition: "opacity 200ms ease 0s",
                opacity: 0,
                visibility: "visible"
              }}
            >
              <div
                className="thumb-vertical"
                style={{
                  position: "relative",
                  display: "block",
                  width: "100%",
                  height: 275,
                  transform: "translateY(0px)"
                }}
              />
            </div>
          </div>
        </div>
        <nav
          className="cb-sidenav dark h-auto self-end"
          data-testid="settings-nav-bottom"
        >
          <a
            className="cb-sidenav-item"
            id="layout:page.payments.title"
            href="/settings"
          >
            <span className="inner">
            <svg style={{width:'25px', height:"25px"}} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' >
    <path
      d='M15 8.913C14.1927 8.90033 13.3909 9.04839 12.6414 9.34856C11.8919 9.64873 11.2096 10.095 10.6342 10.6614C10.0588 11.2279 9.60188 11.9031 9.28998 12.6478C8.97808 13.3925 8.81745 14.1919 8.81745 14.9993C8.81745 15.8066 8.97808 16.606 9.28998 17.3507C9.60188 18.0954 10.0588 18.7706 10.6342 19.3371C11.2096 19.9035 11.8919 20.3498 12.6414 20.6499C13.3909 20.9501 14.1927 21.0982 15 21.0855C16.5976 21.0604 18.1213 20.4082 19.2423 19.2695C20.3632 18.1308 20.9914 16.5971 20.9914 14.9993C20.9914 13.4014 20.3632 11.8677 19.2423 10.729C18.1213 9.59034 16.5976 8.93808 15 8.913ZM10.7865 14.9985C10.7759 14.4388 10.8771 13.8826 11.0839 13.3624C11.2908 12.8422 11.5993 12.3685 11.9914 11.9689C12.3835 11.5694 12.8514 11.252 13.3675 11.0353C13.8837 10.8186 14.4379 10.707 14.9977 10.707C15.5576 10.707 16.1118 10.8186 16.628 11.0353C17.1441 11.252 17.612 11.5694 18.0041 11.9689C18.3962 12.3685 18.7047 12.8422 18.9116 13.3624C19.1184 13.8826 19.2196 14.4388 19.209 14.9985C19.1882 16.1016 18.7353 17.1525 17.9478 17.9253C17.1604 18.6981 16.1011 19.131 14.9977 19.131C13.8944 19.131 12.8351 18.6981 12.0477 17.9253C11.2602 17.1525 10.8073 16.1016 10.7865 14.9985Z'
      fill='#00DC84'
    />
    <path
      d='M18.3674 2.51687C17.3789 -0.838625 12.6209 -0.838625 11.6324 2.51687L11.4554 3.11537C11.3864 3.34954 11.2659 3.56531 11.1027 3.74687C10.9395 3.92843 10.7378 4.07119 10.5123 4.16467C10.2868 4.25815 10.0432 4.3 9.7994 4.28714C9.55562 4.27429 9.3178 4.20706 9.10337 4.09037L8.55438 3.79038C5.47938 2.11788 2.11787 5.48238 3.79188 8.55438L4.09187 9.10187C4.2091 9.31652 4.27673 9.55471 4.28978 9.79893C4.30284 10.0431 4.26099 10.2872 4.16731 10.5131C4.07364 10.739 3.93051 10.9411 3.74847 11.1044C3.56643 11.2677 3.35009 11.3882 3.11537 11.4569L2.51687 11.6324C-0.838625 12.6209 -0.838625 17.3789 2.51687 18.3674L3.11537 18.5444C3.34959 18.6135 3.56537 18.7342 3.74693 18.8976C3.92849 19.0609 4.07123 19.2628 4.16469 19.4884C4.25816 19.714 4.3 19.9577 4.28714 20.2015C4.27428 20.4454 4.20705 20.6833 4.09037 20.8979L3.79038 21.4439C2.11788 24.5189 5.47938 27.8834 8.55438 26.2079L9.10187 25.9094C9.31637 25.7918 9.55449 25.7239 9.79871 25.7106C10.0429 25.6973 10.287 25.739 10.513 25.8326C10.739 25.9261 10.9411 26.0692 11.1045 26.2512C11.2678 26.4333 11.3882 26.6496 11.4569 26.8844L11.6324 27.4829C12.6209 30.8384 17.3789 30.8384 18.3674 27.4829L18.5444 26.8844C18.6135 26.6502 18.7342 26.4344 18.8976 26.2528C19.0609 26.0713 19.2628 25.9285 19.4884 25.8351C19.714 25.7416 19.9577 25.6998 20.2015 25.7126C20.4454 25.7255 20.6833 25.7927 20.8979 25.9094L21.4439 26.2094C24.5189 27.8834 27.8834 24.5174 26.2079 21.4454L25.9094 20.8964C25.7924 20.682 25.7249 20.4441 25.7119 20.2003C25.6989 19.9564 25.7407 19.7127 25.8343 19.4871C25.9278 19.2616 26.0706 19.0598 26.2524 18.8966C26.4341 18.7335 26.65 18.6131 26.8844 18.5444L27.4829 18.3674C30.8384 17.3789 30.8384 12.6209 27.4829 11.6324L26.8844 11.4554C26.6502 11.3864 26.4344 11.2659 26.2529 11.1027C26.0713 10.9395 25.9286 10.7378 25.8351 10.5123C25.7416 10.2868 25.6998 10.0432 25.7126 9.7994C25.7255 9.55562 25.7927 9.3178 25.9094 9.10337L26.2094 8.55438C27.8834 5.47938 24.5174 2.11787 21.4454 3.79188L20.8964 4.09187C20.6818 4.20854 20.4439 4.27571 20.2001 4.28847C19.9562 4.30123 19.7126 4.25926 19.487 4.16562C19.2615 4.07199 19.0598 3.92906 18.8967 3.74733C18.7336 3.56561 18.6132 3.34967 18.5444 3.11537L18.3674 2.51687ZM13.4309 3.04788C13.8914 1.48188 16.1084 1.48188 16.5689 3.04788L16.7459 3.64637C16.8937 4.14922 17.1523 4.61258 17.5026 5.00243C17.8529 5.39228 18.2861 5.69872 18.7703 5.89927C19.2546 6.09981 19.7776 6.18936 20.301 6.16135C20.8243 6.13333 21.3348 5.98846 21.7949 5.73737L22.3409 5.43738C23.7734 4.65738 25.3409 6.22488 24.5609 7.65738L24.2624 8.20638C24.0116 8.66648 23.867 9.17691 23.8392 9.70019C23.8115 10.2235 23.9012 10.7463 24.1019 11.2304C24.3026 11.7145 24.6091 12.1475 24.9989 12.4976C25.3888 12.8478 25.8521 13.1062 26.3549 13.2539L26.9519 13.4309C28.5179 13.8914 28.5179 16.1084 26.9519 16.5689L26.3534 16.7459C25.8507 16.8939 25.3875 17.1527 24.9978 17.503C24.6081 17.8534 24.3018 18.2865 24.1013 18.7707C23.9008 19.2548 23.8112 19.7777 23.8391 20.301C23.8669 20.8243 24.0116 21.3348 24.2624 21.7949L24.5624 22.3409C25.3424 23.7734 23.7749 25.3409 22.3424 24.5609L21.7949 24.2624C21.3346 24.0119 20.8241 23.8675 20.3008 23.8399C19.7775 23.8123 19.2547 23.902 18.7706 24.1027C18.2865 24.3033 17.8534 24.6097 17.5031 24.9994C17.1527 25.3891 16.894 25.8522 16.7459 26.3549L16.5689 26.9519C16.1084 28.5179 13.8914 28.5179 13.4309 26.9519L13.2539 26.3534C13.1055 25.8511 12.8467 25.3883 12.4964 24.9989C12.1461 24.6095 11.7132 24.3034 11.2293 24.103C10.7454 23.9025 10.2228 23.8128 9.69977 23.8404C9.17674 23.868 8.66649 24.0121 8.20638 24.2624L7.65888 24.5624C6.22638 25.3424 4.65888 23.7749 5.43888 22.3424L5.73737 21.7949C5.98846 21.3347 6.13333 20.8241 6.16134 20.3007C6.18936 19.7772 6.09982 19.2541 5.89929 18.7697C5.69876 18.2854 5.39233 17.8521 5.00248 17.5016C4.61264 17.1511 4.14927 16.8924 3.64637 16.7444L3.04788 16.5674C1.48188 16.1069 1.48188 13.8899 3.04788 13.4279L3.64637 13.2524C4.14885 13.1042 4.61181 12.8456 5.00134 12.4953C5.39088 12.1451 5.69711 11.7121 5.8976 11.2281C6.09809 10.7441 6.18776 10.2215 6.16003 9.69834C6.13231 9.17522 5.9879 8.66494 5.73737 8.20487L5.43738 7.65738C4.65738 6.22488 6.22488 4.65738 7.65738 5.43738L8.20638 5.73588C8.66644 5.9864 9.17672 6.13081 9.69984 6.15853C10.223 6.18626 10.7456 6.09659 11.2296 5.8961C11.7136 5.69561 12.1466 5.38938 12.4968 4.99984C12.8471 4.61031 13.1058 4.14735 13.2539 3.64487L13.4309 3.04637V3.04788Z'
      fill='#00DC84'
    />
  </svg>
              <span className="label">{t('settings')}</span>
            </span>
          </a>


          <div
            className="cb-menu cb-sidenav-user-menu dark euclid default fundo-transparente"
            data-headlessui-state=""
            

          >
            
            <menu
       className={` cb-menu-options top left transform ${menuVisible ? 'd-block' : 'd-none'}`}
      aria-labelledby="headlessui-menu-button-:ra:"
      id="headlessui-menu-items-:rb:"
      role="menu"
      tabIndex={0}
      data-headlessui-state={menuVisible ? 'open' : 'closed'}
      ref={LogoutRef}
      
      
    >
      <div className="container" role="none" >
        
        
        <a
          
          href="#"
          rel="noopener noreferrer"
          target="_blank"
          id="headlessui-menu-item-:rc:"
          role="menuitem"
          tabIndex={-1}
          data-headlessui-state=""
          className={`cb-menu-item ${hoveredIndex === 0 ? 'cb-menu-item-hovered' : ''}`}
          onMouseEnter={() => handleMouseEnter(0)}
          onMouseLeave={handleMouseLeave}
        >
  
        </a>
        <a
          className="cb-menu-item"
          id="headlessui-menu-item-:rd:"
          role="menuitem"
          tabIndex={-1}
          data-headlessui-state=""
          onMouseEnter={() => handleMouseEnter(0)}
      onMouseLeave={handleMouseLeave}
      style={{ backgroundColor: hoveredIndex === 0 ? '#00dc84' : 'transparent' }}
      href='/login'
        >
          <div className="item-container default"  onClick={handleLogout} > 
            <svg
              width={16}
              height={16}
              viewBox="0 0 18 16"
              fill="none"
              stroke="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              className="cb-icon cb-icon-logout icon pointer-events-none"
              aria-hidden="true"
              data-testid="icon-logout"
              focusable="false"
              role="img"
            >
              <path
                d="M13.167 11.333 16.5 8m0 0-3.333-3.333M16.5 8H4.833m5 3.333v.834a2.5 2.5 0 0 1-2.5 2.5H4a2.5 2.5 0 0 1-2.5-2.5V3.833a2.5 2.5 0 0 1 2.5-2.5h3.333a2.5 2.5 0 0 1 2.5 2.5v.834"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>Log Out</p>
          </div>
        </a>
      </div>
    </menu>
    
    <a
              className="button"
              id="headlessui-menu-button-:r1:"
              aria-haspopup="menu"
              aria-expanded="false"
              data-headlessui-state=""
              style={{background: 'linear-gradient(90deg, #0a1b23ff 0%, #08383fff 100%)', border: 'none'}}
              onClick={toggleMenu}
              ref={buttonRefLogout}
            >
                 
              <span className="button-wrapper">
                <span className="inner">
                <span className="cb-avatar sm avatar">
  
    { users?.fullName?.charAt(0).toUpperCase()+users?.fullName?.charAt(1).toUpperCase()}
  
</span>
<span className="label">
{users?.fullName?.split(' ')[0]}
</span>

                  <svg
                    width={12}
                    height={12}
                    viewBox="0 0 14 8"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    className="cb-icon cb-icon-chevronup menu-icon pointer-events-none"
                    aria-hidden="true"
                    role="img"
                    focusable="false"
                    data-testid="icon-chevronup"
                  >
                    <path d="M2.145 7.645 7.006 2.93l4.861 4.714a1.275 1.275 0 0 0 1.767 0 1.184 1.184 0 0 0 0-1.713L7.884.355a1.275 1.275 0 0 0-1.767 0L.367 5.932a1.184 1.184 0 0 0 0 1.713c.488.461 1.29.473 1.778 0Z" />
                  </svg>
                </span>
              </span>
              </a>
          </div>
          
        </nav>
      </div>)
};
export default WalletHeader;